/**
 * TODO (Nuxt 3): удалить после перехода на Nuxt 3
 * Эта функция нужна, чтобы показать страницу с ошибкой. Так должен работать showError,
 * но почему-то showError из nuxt/bridge работает не так, как в nuxt 3, поэтому используется error из nuxt 2.
 */

export default function showError(err) {
  var _useNuxtApp = useNuxtApp(),
    error = _useNuxtApp.nuxt2Context.error;
  error(err);
}